import "core-js/modules/es.array.push.js";
import { ref } from 'vue';
import MyNavBarVue from '../../components/MyNavBar.vue';
import { get } from '../../api/utils/request.ts';
import { useRouter } from 'vue-router';
import { closeToast, showLoadingToast } from 'vant';
export default {
  setup() {
    const active = ref(0);
    const Name = ref();
    const CustomerName = ref();
    const CustomerCode = ref();
    const CellPhone = ref();
    const Store = ref();
    const Business = ref();
    const IsIn = ref(0);
    const UId = ref();
    return {
      active,
      Name,
      CustomerName,
      CustomerCode,
      Store,
      Business,
      CellPhone,
      UId,
      IsIn
    };
  },
  components: {
    MyNavBarVue
    //  detail 
  },

  data() {
    return {
      sci: ''
    };
  },
  created() {
    //在组件实例处理完所有与状态相关的选项后调用。
    localStorage.setItem('tabActive', 0);
    // const sci = localStorage.getItem('sci');
    const router = useRouter();
    var param = router.currentRoute.value.query;
    var sci = param.sci;
    if (sci === null || sci === undefined || sci === '') {
      return;
    }
    this.sci = sci;
    this.getInfo(sci);
  },
  mounted() {//在组件被挂载之后调用
  },
  methods: {
    getInfo(sci) {
      console.log(sci);
      showLoadingToast({
        message: '加載中...',
        forbidClick: true,
        duration: 0
      });
      //获取客户信息
      get('/api/services/app/ServiceRecord/GetCustomInfoByUId', {
        UId: sci
      }).then(res => {
        console.log(res);
        if (res.success) {
          this.Name = res.result.name;
          this.CellPhone = res.result.cellPhone;
          this.CustomerName = res.result.customerName;
          this.CustomerCode = res.result.customerCode;
          this.Store = res.result.store;
          this.Business = res.result.business;
          this.IsIn = res.result.isIn;
          closeToast();
        }
      });
    },
    getSci() {},
    ToUrl(url) {
      this.$router.push({
        path: url,
        query: {
          Name: this.Name,
          CellPhone: this.CellPhone,
          CustomerName: this.CustomerName,
          CustomerCode: this.CustomerCode,
          Store: this.Store,
          Business: this.Business
        }
      });
    },
    //  ToUrlUE(url){
    //   this.$router.push({
    //     path:url,
    //     query:{
    //       sci:this.sci
    //     }
    //   })
    //  },
    TabChage(url) {
      this.$router.replace({
        path: url,
        query: {
          sci: this.sci
        }
      });
    }
  }
};